import { Button } from '@ngg/components';
import { XIcon } from '@ngg/icons';
import { cn } from '@ngg/storefront-utils';

const CloseButton = (onClose: () => void, className?: string) => (
  <Button
    type="button"
    onClick={onClose}
    className={cn('border-0 bg-transparent p-0 text-black', className)}>
    <XIcon className="text-base" />
  </Button>
);
export default CloseButton;
